// extracted by mini-css-extract-plugin
export var contentSection = "_b-8";
export var imageSection = "_b-1";
export var productGrid = "_b-0";
export var productImage = "_b-3";
export var productImageContainer = "_b-2";
export var productInfo = "_b-9";
export var purchaseControls = "_b-a";
export var quantityInput = "_b-c";
export var selectedThumbnail = "_b-6";
export var thumbnailContainer = "_b-4";
export var thumbnailImage = "_b-7";
export var thumbnailItem = "_b-5";
export var variantSelect = "_b-b";